/**
 * A time of day in 5-minute steps (Eli, 17 Oct 2026: "We only have 10 increments, so we need to change that to 5"):
 * the hour and the minutes as two plain selects, so a keyboard or a screen reader reaches 4:20 in two choices.
 * The value is minutes from midnight (America/New_York, as every time in the app).
 */
import { useTranslation } from 'react-i18next';

const HOURS = Array.from({ length: 15 }, (_, i) => 7 + i); // 7 a.m. … 9 p.m.
const MINUTES = Array.from({ length: 12 }, (_, i) => i * 5);

export const hourLabel = (h: number) => `${h % 12 === 0 ? 12 : h % 12} ${h < 12 ? 'a.m.' : 'p.m.'}`;

export function TimeSelect({ id, label, value, onChange, help }: { id: string; label: string; value: number; onChange: (minutes: number) => void; help?: string }) {
  const { t } = useTranslation();
  const h = Math.floor(value / 60);
  const m = value % 60 - ((value % 60) % 5);
  return (
    <fieldset className="field" data-testid={id}>
      <legend>{label}</legend>
      <div className="grid-2">
        <div>
          <label htmlFor={`${id}-h`} className="help">
            {t('vb.hour')}
          </label>
          <select id={`${id}-h`} className="input" value={String(h)} onChange={(e) => onChange(Number(e.target.value) * 60 + m)} data-testid={`${id}-h`}>
            {HOURS.map((x) => (
              <option key={x} value={String(x)}>
                {hourLabel(x)}
              </option>
            ))}
          </select>
        </div>
        <div>
          <label htmlFor={`${id}-m`} className="help">
            {t('vb.minutes')}
          </label>
          <select id={`${id}-m`} className="input" value={String(m)} onChange={(e) => onChange(h * 60 + Number(e.target.value))} data-testid={`${id}-m`}>
            {MINUTES.map((x) => (
              <option key={x} value={String(x)}>
                :{String(x).padStart(2, '0')}
              </option>
            ))}
          </select>
        </div>
      </div>
      {help ? <p className="help">{help}</p> : null}
    </fieldset>
  );
}
